import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const coverHeight = size === 'small' ? 'h-[180px]' : size === 'large' ? 'h-[340px]' : 'h-[260px]';
  const titleSize = size === 'small' ? 'text-xs' : 'text-sm';
  const authorSize = size === 'small' ? 'text-[10px]' : 'text-xs';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300"
      data-product-shop
    >
      <div className={`relative ${coverHeight} overflow-hidden`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 天天漫画网下拉式免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex gap-1.5 flex-wrap">
          {comic.isHot && (
            <span className="px-2 py-0.5 rounded-md text-[10px] font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
              HOT
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 rounded-md text-[10px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
              NEW
            </span>
          )}
          <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-foreground-950/70 text-background-50 whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        {size !== 'small' && (
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <p className="text-[10px] text-white/90 line-clamp-2 leading-relaxed">
              {comic.description}
            </p>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className={`${titleSize} font-semibold text-foreground-950 truncate`}>
          {comic.title}
        </h3>
        <div className="flex items-center justify-between mt-1.5">
          <span className={`${authorSize} text-foreground-600 truncate`}>
            {comic.author}
          </span>
          {size !== 'small' && (
            <div className="flex items-center gap-1 flex-shrink-0">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-[10px] text-accent-500"></i>
              </span>
              <span className="text-[10px] text-accent-500 font-medium">{comic.rating}</span>
            </div>
          )}
        </div>
        {size === 'large' && (
          <div className="flex items-center gap-2 mt-2 flex-wrap">
            {comic.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-md text-[10px] text-secondary-700 bg-secondary-100 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}